import React, { useState,useEffect} from 'react';
import { Button } from 'react-bootstrap';
import AttendanceOpenEventDatatable from './AttendanceOpenEventDatatable';




const AttendanceOpenEventTab = (props) => {

    
      
    const [checkTime, setCheckTime] = useState(null);

   

    useEffect(() => {      
      setCheckTime(Date.now());
    }, [props.isActive])

  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <AttendanceOpenEventDatatable                    
            checkTime={checkTime}                            
          />
         
        
        </div>
    );
};

export default AttendanceOpenEventTab;